import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const MODES = {
  base64: {
    label: 'Base64',
    encode: (text) => window.btoa(unescape(encodeURIComponent(text))),
    decode: (text) => decodeURIComponent(escape(window.atob(text))),
  },
  url: {
    label: 'URL',
    encode: (text) => encodeURIComponent(text),
    decode: (text) => decodeURIComponent(text),
  },
}

const Base64UrlEncoder = () => {
  useDocumentMeta({
    title: 'Codificador e Decodificador Base64 / URL  jarder.dev',
    description:
      'Codifique e decodifique texto em Base64 ou URL encode/decode ' +
      'instantaneamente, direto no navegador. Grátis, sem cadastro.',
  })

  const [mode, setMode] = useState('base64')
  const [input, setInput] = useState('')
  const [output, setOutput] = useState('')
  const [error, setError] = useState('')

  const run = (action) => {
    try {
      setOutput(MODES[mode][action](input))
      setError('')
      trackEvent('tool_generate', { tool: 'base64_url', mode, action })
    } catch {
      setError('Não foi possível processar esse texto (formato inválido).')
      setOutput('')
    }
  }

  const copy = () => {
    navigator.clipboard.writeText(output)
    trackEvent('tool_copy', { tool: 'base64_url' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Codificador Base64 / URL</h1>
      <p className="tool-disclaimer">
        Tudo processado localmente no seu navegador  nenhum texto é
        enviado para nenhum servidor.
      </p>

      <div className="tool-field">
        <label htmlFor="mode">Modo</label>
        <select id="mode" value={mode} onChange={(e) => setMode(e.target.value)}>
          {Object.entries(MODES).map(([key, m]) => (
            <option key={key} value={key}>
              {m.label}
            </option>
          ))}
        </select>
      </div>

      <div className="tool-field">
        <label htmlFor="input">Texto de entrada</label>
        <textarea
          id="input"
          rows="6"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>

      <div className="tool-result-actions" style={{ marginBottom: 20 }}>
        <button
          type="button"
          className="tool-button"
          onClick={() => run('encode')}
        >
          Codificar
        </button>
        <button
          type="button"
          className="tool-button tool-button-secondary"
          onClick={() => run('decode')}
        >
          Decodificar
        </button>
      </div>

      {error && <p className="tool-error">{error}</p>}

      {output && (
        <div className="tool-result-card">
          <span className="tool-result-label">Resultado</span>
          <span className="tool-result-value" style={{ wordBreak: 'break-all' }}>
            {output}
          </span>
          <div className="tool-result-actions">
            <button
              type="button"
              className="tool-button tool-button-secondary"
              onClick={copy}
            >
              Copiar
            </button>
          </div>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Base64 ou URL encode: qual usar</h2>
        <p>
          <strong>Base64</strong> transforma qualquer texto (ou dados
          binários) em uma sequência de letras, números e os símbolos{' '}
          <code>+</code>, <code>/</code> e <code>=</code>. É usado para
          embutir imagens em CSS/HTML, anexos de e-mail, tokens de
          autenticação e configurações que precisam viajar como texto
          puro.
        </p>
        <p>
          <strong>URL encode</strong> (percent-encoding) substitui
          caracteres que têm significado especial numa URL  como
          espaço, <code>&amp;</code> e <code>?</code>  por sequências{' '}
          <code>%XX</code>, para que a URL continue válida. Use quando for
          colocar texto livre dentro de um parâmetro de link ou query
          string.
        </p>
      </div>
    </div>
  )
}

export default Base64UrlEncoder
